import { render, staticRenderFns } from "./ManageMasterData.vue?vue&type=template&id=490048e0&scoped=true"
import script from "./ManageMasterData.vue?vue&type=script&lang=js"
export * from "./ManageMasterData.vue?vue&type=script&lang=js"
import style0 from "./ManageMasterData.vue?vue&type=style&index=0&id=490048e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490048e0",
  null
  
)

export default component.exports